// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public//images/login-bg-img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public//images//login-bg-img.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: auto; /* or overflow-y: auto */
}



:root {
  /* --primary-purple: #6c63ff; */
  --primary-purple: #F27457;
  --secondary-color: #216061;
  --custom-black: #3a3a3a;


}

.text-color{
  color: #e02208;
}


.bell-badge{
  color: black!important;
  background-color: #fff;
}


.page-title-color{
  color: var(--custom-black);
}

.custom-text-purple{
  color: var(--primary-purple) !important;
}
.custom-bg-purple{
  background-color: var(--primary-purple) !important;
  color: #fff !important;
  /* width: fit-content; */
}
.custom-button-style{
  background-color: var(--primary-purple) !important;
  color: #fff !important;
  /* width: fit-content; */
}

.custom-bg-purple .page-link {
  color: var(--primary-purple) !important;
  border-color: var(--primary-purple) !important;
}

.custom-bg-purple .page-item.active .page-link {
  background-color: var(--primary-purple) !important;
  border-color: var(--primary-purple) !important;
  color: white !important;
}


.custom-text-purple {
  color: var(--primary-purple) !important;
}

.bg-custom-gray {
  background-color: #f1f1f1;
  /* padding: 5px; */
  cursor: pointer;
}


.custom-input-style{

}

.custom-input-style{
  background-color: #f3e8ff; /* light purple */
  border: 1px solid #ccc;
}

.custom-input-style:focus {
  background-color: #e4861a; /* slightly darker purple */
  border-color: #96f755; /* purple border */
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(168, 85, 247, 0.25);
}




.button-rounded .nav-link {
  border-radius: 50px !important;
  color: var(--primary-purple) !important;
}

/* Active tab styling */
.button-rounded .nav-link.active {
  background-color: var(--primary-purple) !important;
  color: white !important;
}



.bg-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
}

.custom-btn-purple {
  background-color: var(--primary-purple) !important;
  color: #fff !important;
  border-color: var(--primary-purple) !important;
}


.auth-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  min-height: 100vh;
}

.password-toggle-icon {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
}



.nav-link {
  color: #333;
  text-decoration: none;
}

.active-sidebar {
  background-color: var(--primary-purple) !important;
  color: #fff !important;
  border-radius: 8px;
}

.bg-custom-gray {
  background-color: #e7e7e7;
}

.button-rounded{
  border-radius: 50px;
  padding: 1px 1px 2px 1px;
  font-size: 14px;
}

.page-item {
  cursor: pointer;
}
.page-item.disabled {
  cursor: not-allowed;
}


.cursor-pointer{
  cursor: pointer;
}




/* Table Custom CSS */

/* Override thead background and text color */
/* Header customization */
.custom-table .table thead {
  background-color: #003366 !important;
}

.custom-table .table thead th {
  color: black !important;
  background-color: #f3f3f3 !important;
}

/* Ensure hover works on tbody rows */
.custom-table .table tbody tr:hover td {
  /* background-color: #e61515 !important; */
  /* color: white !important;  */
}




/* Pagination Custom CSS */

.custom-pagination .page-link {
  /* background-color: var(--primary-purple) !important; */
  background-color: var(--primary-purple) !important; 

  color: white !important;
  border: none;
  margin: 0 4px;
  border-radius: 8px;
}

.custom-pagination .page-item.active .page-link {
  background-color: var(--primary-purple) !important;

  color: #fff !important;
}

.custom-pagination .page-item.disabled .page-link {
  background-color: #e0e0e0 !important;
  color: #aaa !important;
}




/* App.css or a relevant CSS file */
.hide-arrow-when-disabled:disabled {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none !important; /* for some browsers */
}


.remark-list-scroll{
  max-height: 210px;
  overflow-y: auto;
}



/* Layout Styles */
.layout-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden; /* prevent body scroll */
}

.layout-body {
  display: flex;
  flex: 1 1;
  overflow: hidden;
  /* margin-top: 56px;  */
}

.sidebar {
  width: 250px;
  overflow-y: auto;
  height: calc(100vh - 56px); /* full height minus Topbar */
  position: relative;
}

/* sidebarStyles.css */
.sidebar-gradient {
  background: linear-gradient(to bottom, #916cd6, #b44cdd, #9e27a8);
  /* color: white; */
  min-height: 94vh;
}

.topbar-gradient {
  /* background: linear-gradient(to left, #916cd6, #b44cdd, #9e27a8) !important; */
  background: linear-gradient(to left, #F27457, #F8B9AB, #FBD5CD) !important;

  /* background-color: red !important; */
  /* color: white; */
  /* height: 60px; Adjust as needed */

  /* padding: 0 1rem; */
}

.menu-button-position{

  width: fit-content;
  position: absolute;
  top: 90px;
  
}
.main-content {
  flex: 1 1;
  overflow-y: auto;
  height: calc(100vh - 56px); /* full height minus Topbar */
  padding: 20px;
  background-color: #f9f9f9;
}

.content-wrapper {
  min-height: 100%;
}
/* 
.modal-backdrop {
  background-color: rgba(7, 6, 7, 0.9) !important; 
} */



/* custom.css */
.custom-accordion .accordion-item {
  background-color: #fff; /* light purple background */
  border-color: #F8B9AB;
}

.custom-accordion .accordion-header {
  background-color: #FBD5CD; /* slightly different purple */
  color: var(--primary-purple); /* text color */
}

.custom-accordion .accordion-button:not(.collapsed) {
  background-color: #FBD5CD;
  color: var(--primary-purple);
  box-shadow: none;
}


.sidebar-position{
  margin-top: 16px;
}


@media (min-width: 991px) {
  .sidebar.hide:not(.sidebar-end) {
      margin-left: 0 !important;
      /* background-color: red; */
  }
}



@media (max-width: 991.98px) {

  .sidebar-position{
    margin-top: 75px;
  }
  
  
}


@media (max-width: 768px) {

  .sidebar-position{
    margin-top:  75px;
  }
  
  
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,cAAc,EAAE,wBAAwB;AAC1C;;;;AAIA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;;;AAGzB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;AACA;EACE,kDAAkD;EAClD,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,kDAAkD;EAClD,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,kDAAkD;EAClD,8CAA8C;EAC9C,uBAAuB;AACzB;;;AAGA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;;AAEA;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,sBAAsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,qBAAqB,EAAE,kBAAkB;EACzC,aAAa;EACb,iDAAiD;AACnD;;;;;AAKA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA,uBAAuB;AACvB;EACE,kDAAkD;EAClD,uBAAuB;AACzB;;;;AAIA;EACE,yDAA2D;EAC3D,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;EAClD,sBAAsB;EACtB,8CAA8C;AAChD;;;AAGA;EACE,yDAA4D;EAC5D,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;;;AAIA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kDAAkD;EAClD,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;;AAGA;EACE,eAAe;AACjB;;;;;AAKA,qBAAqB;;AAErB,6CAA6C;AAC7C,yBAAyB;AACzB;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;;;;AAKA,0BAA0B;;AAE1B;EACE,wDAAwD;EACxD,kDAAkD;;EAElD,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;;EAElD,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;;;;AAKA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,iCAAiC,EAAE,sBAAsB;AAC3D;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;;AAIA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB,EAAE,wBAAwB;AAC5C;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B,EAAE,6BAA6B;EACzD,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,iEAAiE;EACjE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gFAAgF;EAChF,0EAA0E;;EAE1E,sCAAsC;EACtC,kBAAkB;EAClB,mCAAmC;;EAEnC,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;;AAEX;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,0BAA0B,EAAE,6BAA6B;EACzD,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;;;GAGG;;;;AAIH,eAAe;AACf;EACE,sBAAsB,EAAE,4BAA4B;EACpD,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,4BAA4B,EAAE,eAAe;AAC/C;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;AAClB;;;AAGA;EACE;MACI,yBAAyB;MACzB,2BAA2B;EAC/B;AACF;;;;AAIA;;EAEE;IACE,gBAAgB;EAClB;;;AAGF;;;AAGA;;EAEE;IACE,iBAAiB;EACnB;;;AAGF","sourcesContent":["\nhtml, body, #root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: auto; /* or overflow-y: auto */\n}\n\n\n\n:root {\n  /* --primary-purple: #6c63ff; */\n  --primary-purple: #F27457;\n  --secondary-color: #216061;\n  --custom-black: #3a3a3a;\n\n\n}\n\n.text-color{\n  color: #e02208;\n}\n\n\n.bell-badge{\n  color: black!important;\n  background-color: #fff;\n}\n\n\n.page-title-color{\n  color: var(--custom-black);\n}\n\n.custom-text-purple{\n  color: var(--primary-purple) !important;\n}\n.custom-bg-purple{\n  background-color: var(--primary-purple) !important;\n  color: #fff !important;\n  /* width: fit-content; */\n}\n.custom-button-style{\n  background-color: var(--primary-purple) !important;\n  color: #fff !important;\n  /* width: fit-content; */\n}\n\n.custom-bg-purple .page-link {\n  color: var(--primary-purple) !important;\n  border-color: var(--primary-purple) !important;\n}\n\n.custom-bg-purple .page-item.active .page-link {\n  background-color: var(--primary-purple) !important;\n  border-color: var(--primary-purple) !important;\n  color: white !important;\n}\n\n\n.custom-text-purple {\n  color: var(--primary-purple) !important;\n}\n\n.bg-custom-gray {\n  background-color: #f1f1f1;\n  /* padding: 5px; */\n  cursor: pointer;\n}\n\n\n.custom-input-style{\n\n}\n\n.custom-input-style{\n  background-color: #f3e8ff; /* light purple */\n  border: 1px solid #ccc;\n}\n\n.custom-input-style:focus {\n  background-color: #e4861a; /* slightly darker purple */\n  border-color: #96f755; /* purple border */\n  outline: none;\n  box-shadow: 0 0 0 0.2rem rgba(168, 85, 247, 0.25);\n}\n\n\n\n\n.button-rounded .nav-link {\n  border-radius: 50px !important;\n  color: var(--primary-purple) !important;\n}\n\n/* Active tab styling */\n.button-rounded .nav-link.active {\n  background-color: var(--primary-purple) !important;\n  color: white !important;\n}\n\n\n\n.bg-image {\n  background-image: url('../public//images/login-bg-img.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n}\n\n.custom-btn-purple {\n  background-color: var(--primary-purple) !important;\n  color: #fff !important;\n  border-color: var(--primary-purple) !important;\n}\n\n\n.auth-bg {\n  background-image: url('../public//images//login-bg-img.jpg');\n  background-size: cover;\n  background-position: center;\n  min-height: 100vh;\n}\n\n.password-toggle-icon {\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #6c757d;\n}\n\n\n\n.nav-link {\n  color: #333;\n  text-decoration: none;\n}\n\n.active-sidebar {\n  background-color: var(--primary-purple) !important;\n  color: #fff !important;\n  border-radius: 8px;\n}\n\n.bg-custom-gray {\n  background-color: #e7e7e7;\n}\n\n.button-rounded{\n  border-radius: 50px;\n  padding: 1px 1px 2px 1px;\n  font-size: 14px;\n}\n\n.page-item {\n  cursor: pointer;\n}\n.page-item.disabled {\n  cursor: not-allowed;\n}\n\n\n.cursor-pointer{\n  cursor: pointer;\n}\n\n\n\n\n/* Table Custom CSS */\n\n/* Override thead background and text color */\n/* Header customization */\n.custom-table .table thead {\n  background-color: #003366 !important;\n}\n\n.custom-table .table thead th {\n  color: black !important;\n  background-color: #f3f3f3 !important;\n}\n\n/* Ensure hover works on tbody rows */\n.custom-table .table tbody tr:hover td {\n  /* background-color: #e61515 !important; */\n  /* color: white !important;  */\n}\n\n\n\n\n/* Pagination Custom CSS */\n\n.custom-pagination .page-link {\n  /* background-color: var(--primary-purple) !important; */\n  background-color: var(--primary-purple) !important; \n\n  color: white !important;\n  border: none;\n  margin: 0 4px;\n  border-radius: 8px;\n}\n\n.custom-pagination .page-item.active .page-link {\n  background-color: var(--primary-purple) !important;\n\n  color: #fff !important;\n}\n\n.custom-pagination .page-item.disabled .page-link {\n  background-color: #e0e0e0 !important;\n  color: #aaa !important;\n}\n\n\n\n\n/* App.css or a relevant CSS file */\n.hide-arrow-when-disabled:disabled {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: none !important; /* for some browsers */\n}\n\n\n.remark-list-scroll{\n  max-height: 210px;\n  overflow-y: auto;\n}\n\n\n\n/* Layout Styles */\n.layout-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden; /* prevent body scroll */\n}\n\n.layout-body {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n  /* margin-top: 56px;  */\n}\n\n.sidebar {\n  width: 250px;\n  overflow-y: auto;\n  height: calc(100vh - 56px); /* full height minus Topbar */\n  position: relative;\n}\n\n/* sidebarStyles.css */\n.sidebar-gradient {\n  background: linear-gradient(to bottom, #916cd6, #b44cdd, #9e27a8);\n  /* color: white; */\n  min-height: 94vh;\n}\n\n.topbar-gradient {\n  /* background: linear-gradient(to left, #916cd6, #b44cdd, #9e27a8) !important; */\n  background: linear-gradient(to left, #F27457, #F8B9AB, #FBD5CD) !important;\n\n  /* background-color: red !important; */\n  /* color: white; */\n  /* height: 60px; Adjust as needed */\n\n  /* padding: 0 1rem; */\n}\n\n.menu-button-position{\n\n  width: fit-content;\n  position: absolute;\n  top: 90px;\n  \n}\n.main-content {\n  flex: 1;\n  overflow-y: auto;\n  height: calc(100vh - 56px); /* full height minus Topbar */\n  padding: 20px;\n  background-color: #f9f9f9;\n}\n\n.content-wrapper {\n  min-height: 100%;\n}\n/* \n.modal-backdrop {\n  background-color: rgba(7, 6, 7, 0.9) !important; \n} */\n\n\n\n/* custom.css */\n.custom-accordion .accordion-item {\n  background-color: #fff; /* light purple background */\n  border-color: #F8B9AB;\n}\n\n.custom-accordion .accordion-header {\n  background-color: #FBD5CD; /* slightly different purple */\n  color: var(--primary-purple); /* text color */\n}\n\n.custom-accordion .accordion-button:not(.collapsed) {\n  background-color: #FBD5CD;\n  color: var(--primary-purple);\n  box-shadow: none;\n}\n\n\n.sidebar-position{\n  margin-top: 16px;\n}\n\n\n@media (min-width: 991px) {\n  .sidebar.hide:not(.sidebar-end) {\n      margin-left: 0 !important;\n      /* background-color: red; */\n  }\n}\n\n\n\n@media (max-width: 991.98px) {\n\n  .sidebar-position{\n    margin-top: 75px;\n  }\n  \n  \n}\n\n\n@media (max-width: 768px) {\n\n  .sidebar-position{\n    margin-top:  75px;\n  }\n  \n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
